import { useGLTF, useTexture } from '@react-three/drei';
import { forwardRef } from 'react';
import * as THREE from 'three';

const Springs = forwardRef(({ position = [0, 0, 0], rotation = [0, 0, 0], scale = [1, 1, 1] }, ref) => {
    const { nodes } = useGLTF('./models/ccr/springs.glb');
    const texture = useTexture('./textures/ccr/springs.jpg');
    texture.flipY = false;

    return (
        <mesh
            ref={ref}
            geometry={nodes.springs.geometry}
            onClick={(event) => event.stopPropagation()}
            onPointerEnter={(event) => event.stopPropagation()}
            position={position}
            rotation={rotation}
            scale={scale}
        >
            <meshBasicMaterial 
                map={texture} 
                transparent={true} 
                opacity={1}
                // depthWrite={false} 
                blending={THREE.NormalBlending} 
            />
        </mesh>
    );
});

export default Springs;
